import { call, take, put }    from 'redux-saga/effects';
import axios                  from 'axios';
import { CHANGE_MODAL_STATE, CREATE_ERROR } from 'actions';
import { SET_FOLLOW_LINK }    from 'actions/componentsActions';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/joinLesson.php';

function* joinLesson(): Generator<any,any,any> {
  while(true) {
    try {

        const input = yield take('JOIN_LESSON_SAGA');
        yield put(CHANGE_MODAL_STATE('followLinkNotFound')); 

        if (process.env.NODE_ENV === 'development') {
          yield put(SET_FOLLOW_LINK('test123'))
          yield put(CHANGE_MODAL_STATE('showFollowLink')); 

        }
        if (process.env.NODE_ENV === 'production') {

            yield put(CHANGE_MODAL_STATE('loader')); 

            const res = yield call( axios.post, endpoint, { lessonNum: +input.payload });        
            if (!!res && !!res.data && !!res.data.result && !!res.data.result[0]) {

              const followLink = res.data.result[0].following_link;
              const arr        = followLink.split(',').map((val: string) => { return +val })
              const link       = String.fromCharCode.apply(null, arr)
              yield put(SET_FOLLOW_LINK(link))
              yield put(CHANGE_MODAL_STATE('showFollowLink')); 
            }
            else {
              yield put(CHANGE_MODAL_STATE('followLinkNotFound')); 
            }
        }
        
    }
    catch(err) {
      yield put(CREATE_ERROR());
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default joinLesson;











